import React from "react";
import { observer } from "mobx-react";
import { AuthorCollectingSocietyViewStore } from "../../store";
import { AuthorCollectingSocietyViewForm } from "./AuthorCollectingSocietyViewForm";
import { ErrorDialog } from "../../../../common/controls";

export type AuthorCollectingSocietyViewProps = {
  authorCollectingSocietyViewStore: AuthorCollectingSocietyViewStore;
};

export const AuthorCollectingSocietyView: React.FC<AuthorCollectingSocietyViewProps> =
  observer(({ authorCollectingSocietyViewStore }) => {
    return (
      <div>
        <AuthorCollectingSocietyViewForm
          collectingSocietyValue={
            authorCollectingSocietyViewStore.collectingSocietyValue
          }
          memberNumber={authorCollectingSocietyViewStore.memberNumberValue}
          territoriesValues={authorCollectingSocietyViewStore.territoriesValues}
          onPrint={(handlePrint: () => void) =>
            authorCollectingSocietyViewStore.printAuthorCollectingSociety(
              handlePrint
            )
          }
          onCancel={() =>
            authorCollectingSocietyViewStore.cancelAuthorCollectingSociety()
          }
          onEdit={
            authorCollectingSocietyViewStore.isEditEnabled
              ? () =>
                  authorCollectingSocietyViewStore.editAuthorCollectingSociety()
              : undefined
          }
        />
        <ErrorDialog
          open={authorCollectingSocietyViewStore.errorDialogOpened}
          title={authorCollectingSocietyViewStore.errorTitle}
          description={authorCollectingSocietyViewStore.errorDescription}
          onClose={() => authorCollectingSocietyViewStore.closeErrorDialog()}
        />
      </div>
    );
  });
